import React, { FC } from "react"
import { GatsbyImage } from "gatsby-plugin-image"
import styled from "styled-components"

import { getImgixImageData } from "@utils"

import NewsletterForm from "@components/HubspotForm/presets/NewsletterForm"

export const PostsLandingSubscribeCalloutDIV = styled.div`
  background: var(--color--purple-200);
  border-radius: var(--border-radius--M);
  display: flex;
  flex-direction: column;
  gap: 40px;
  justify-content: flex-start;
  justify-content: space-between;
  overflow: hidden;
  padding: 150px 38px 60px;
  position: relative;

  .gatsby-image-wrapper {
    position: absolute;
    right: 0;
    top: 0;
    z-index: 0;
  }

  h3 {
    z-index: 2;
  }

  h3,
  p {
    text-wrap: balance;
  }
`

const PostsLandingSubscribeCallout: FC = () => (
  <PostsLandingSubscribeCalloutDIV>
    <GatsbyImage
      alt=""
      image={getImgixImageData(
        `/images/components/PostsLandingSubscribeCallout/PostsLandingSubscribeCallout--texture.png`,
        396,
        2.64
      )}
      style={{
        position: "absolute",
      }}
    />
    <div className="content">
      <h4 className="type--mono-M color--text-default">The Supportive Weekly</h4>
      <h3>Our best content in your&nbsp;inbox</h3>
      <p className="type--text-L margin-bottom--0">
        Fresh perspective, hot takes, and practical advice for delivering exceptional customer&nbsp;experiences.
      </p>
    </div>
    <NewsletterForm isCompact />
  </PostsLandingSubscribeCalloutDIV>
)

export default PostsLandingSubscribeCallout